import { ImageAsset } from "res";

export default function NoMyBillersMessage(props) {
    return (
        <div className="row-container">
            <div className="flex-container flex-horizontal align-center row-main-content">
                <ImageAsset id="CompanyBillerImage" className="show-on-desktop blue-icon logo set-width logo-container" />
                <ImageAsset id="CompanyBillerImage" className="logo set-width logo-container show-on-mobile" />

                <div className="flex-width">
                    <span>You don't have any billers in your profile. Search for billers above to get started.</span>
                </div>
            </div>
        </div>
    );
}